import { useEffect } from 'react'
import { useSelector } from 'react-redux'

// Components

import SectionHeading from '../../../../UI/SectionHeading/SectionHeading';
import TextInput from '../../../../UI/FormInput/TextInput';
import MaskInput from '../../../../UI/FormInput/MaskInput';
import DropDownInput from '../../../../UI/FormInput/DropDownInput';
import RadioInput from '../../../../UI/FormInput/RadioInput';
import FormInputGroup from '../../../../UI/FormInputGroup/FormInputGroup';
import Button from '../../../../UI/Button/Button';
import ButtonWithIcon from '../../../../UI/ButtonWithIcon/ButtonWithIcon';
import AssociateFields from '../AssociateFields';

// Utilities

import { formatDropDownOptions, addItemToArray, removeItemFromArray } from '../../../../../utilities/helper-functions';

// Constants

import { TIN_MASK_FORMAT } from '../../../../../config/constants';

import { initialValues } from '../InitialValues';

export default function KnowMore({formik, goToPreviousModule}) {
    // Dropdown Options
    const dropDownOptions = useSelector((state) => state.options.dropDownOptions);

    useEffect(() => {
        if (!['1', '2', '5', '6'].includes(formik.values?.cliente?.tipoCliente)) {
            formik.setFieldValue('pep.pregunta1.nombreCargo', '0')
        }
    }, [formik.values?.cliente?.tipoCliente]);

    return (
    <>
        <SectionHeading text={'Conozcámonos un poco más'} />
        {['1', '2', '5', '6'].includes(formik.values?.cliente?.tipoCliente) &&
        <>
        <p>¿Usted ha desempeñado alguno de los cargos listados durante los últimos 10 años?</p>

        <FormInputGroup>

            <DropDownInput
                formik={formik}
                fieldName={'pep.pregunta1.nombreCargo'}
                label={'Cargos'}
                options={formatDropDownOptions(dropDownOptions?.data?.positions)}
                isRequired={true}
            />

        </FormInputGroup>

        {formik.values?.pep?.pregunta1?.nombreCargo && formik.values?.pep?.pregunta1?.nombreCargo !== '0' &&
        <FormInputGroup>

            <TextInput
                formik={formik}
                fieldName={'pep.pregunta1.nombreEnteAdscrito'}
                label={'Nombre del ente de adscripción'}
                maxLength={80}
                isRequired={true}
            />
            
            <DropDownInput
                formik={formik}
                fieldName={'pep.pregunta1.pais'}
                label={'Pais'}
                options={formatDropDownOptions(dropDownOptions?.data?.countries)}
                isRequired={true}
            />

        </FormInputGroup>}
        </>}

        <RadioInput
            formik={formik}
            fieldName={'pep.hasAssociate'}
            label={'¿Usted tiene parentesco o es asociado con alguien que haya desempeñado un alto cargo político en los últimos diez años?'}
            options={[{label: 'Sí', value: 'si'},{label: 'No', value: 'no'},]}
            isGroup={true}
            isRequired={true}
        />

        {formik.values?.pep?.hasAssociate === 'si' &&
            <div style={{marginBottom: '2rem'}}>
                {formik.values?.pep?.pregunta2?.map((associate, index) => (
                    <AssociateFields
                        i={index}
                        key={index}
                        formik={formik}
                        index={index}
                    />
                ))}

                <ButtonWithIcon
                    action={() => addItemToArray(formik, 'pep.pregunta2', initialValues.pep?.pregunta2[0])}
                    label={'Añadir Asociado'}
                    disabled={formik.values?.pep?.pregunta2?.length === 5}
                />
    
                <ButtonWithIcon
                    action={() => removeItemFromArray(formik, 'pep.pregunta2')}
                    icon={'delete'}
                    disabled={formik.values?.pep?.pregunta2?.length === 1}
                />
            </div>
        }

        <RadioInput
            formik={formik}
            fieldName={'fatca.tieneRelacion'}
            label={'¿Posee alguna de las siguientes relaciones con los EEUU?'}
            extraLabel={
                <p className='extra-label'>
                - Residencia<br/>
                - Nacionalidad<br/>
                - Ciudadano<br/>
                - ¿Posee una dirección de correspondencia en los EEUU?<br/>
                - ¿Cuenta con apoderados en los estados unidos ¿que puedan obligarlo o contratar por usted?<br/>
                - Posee Número de identificación del contribuyente (TIN)<br/>
                </p>
            }
            options={[{label: 'Sí', value: 'si'},{label: 'No', value: 'no'},]}
            isGroup={true}
            isRequired={true}
        />

        {formik.values?.fatca?.tieneRelacion === 'si' &&
        <FormInputGroup>

            <MaskInput
                formik={formik}
                fieldName={'fatca.numitin'}
                label={'Coloque el número de identificación TIN'}
                mask={TIN_MASK_FORMAT}
                helpText={'Recuerda que por tu relación con los EEUU deberás tener a la disposición del banco unos de los siguientes formatos, según tu condición: formas W-8BEN-E, W8 y/o W9'}
            />

        </FormInputGroup>}

        <div className='form-actions'>

            <Button
                action={() => goToPreviousModule(0)}
                label={'Regresa'}
                secondaryStyle={true}
            />

            <Button
                type="submit"
                action={formik.handleSubmit}
                label={'Continua'}
            />

        </div>
    </>
  )
}
